import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List} from 'immutable';
import {CheckboxChip} from '@albert-io/atomic';

export default class EmailChips extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    emails: ImmutablePropTypes.listOf(PropTypes.string),
    handleClick: PropTypes.func
  };

  static defaultProps = {
    emails: List(),
    handleClick: () => {}
  };

  render() {
    if (this.props.emails.isEmpty()) {
      return null;
    }
    return (
      <div
        aria-owns={[...this.props.emails].join(' ')}
        className={this.props.className}
        role='listbox'
      >
        {this.props.emails.map((email) => {
          return (
            <CheckboxChip
              as='label'
              defaultChecked
              id={email}
              key={email}
              onChange={() => this.props.handleClick(email)}
              role='option'
              size='small'
            >
              {email}
            </CheckboxChip>
          );
        })}
      </div>
    );
  }
}
